{
  "title": "Jump",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a grasshopper’s hind leg)",
  "duration": "1 minute",
  "description": [
    "You touch a creature. The creature’s jump distance is tripled until the spell ends."
  ],
  "spellLists": ["artificer", "druid", "ranger", "sorcerer", "wizard"]
}
